import { render, staticRenderFns } from "./TechStav1.vue?vue&type=template&id=63d8b0d2&"
import script from "./TechStav1.vue?vue&type=script&lang=ts&"
export * from "./TechStav1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports